import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    minWidth: 0,
    py: 2,
    width: '100%',
  },
  title: {
    color: 'text.primary',
    fontSize: 24,
    fontWeight: 600,
    textAlign: 'center',
  },
  subtitle: {
    color: 'text.secondary',
    mt: 1,
    mb: 4,
    textAlign: 'center',
  },
  optionCard: {
    borderColor: 'divider',
    borderRadius: 3,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    transition: 'border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease',
    '&:hover': {
      borderColor: 'primary.main',
      boxShadow: 4,
      transform: 'translateY(-3px)',
    },
  },
  optionAction: {
    alignItems: 'stretch',
    display: 'flex',
    flex: 1,
  },
  recommendedCard: {
    borderColor: 'primary.main',
    boxShadow: (theme: Theme) =>
      `0 8px 24px ${theme.palette.primary.main}1A`,
  },
  optionContent: {
    boxSizing: 'border-box',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minWidth: 0,
    p: { xs: 2, sm: 3 },
    width: '100%',
    '&:last-child': {
      pb: { xs: 2, sm: 3 },
    },
  },
  optionHeader: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
  },
  iconContainer: {
    alignItems: 'center',
    bgcolor: 'primary.main',
    borderRadius: '50%',
    display: 'flex',
    height: 48,
    justifyContent: 'center',
    width: 48,
  },
  optionIcon: {
    color: 'primary.contrastText',
    fontSize: 28,
  },
  recommendedLabel: {
    bgcolor: 'primary.main',
    borderRadius: 4,
    color: 'primary.contrastText',
    fontSize: 12,
    fontWeight: 600,
    px: 1.5,
    py: 0.5,
  },
  optionTitle: {
    flex: 1,
    fontSize: 19,
    fontWeight: 600,
    mt: 2.5,
  },
  optionButton: {
    alignItems: 'center',
    border: 1,
    borderColor: 'primary.main',
    borderRadius: 1,
    boxSizing: 'border-box',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    maxWidth: '100%',
    minHeight: 42,
    mt: 3,
    px: 2,
    width: '100%',
  },
  recommendedButton: {
    bgcolor: 'primary.main',
    color: 'primary.contrastText',
  },
  manualButton: {
    bgcolor: 'background.paper',
    color: 'primary.main',
  },
  optionButtonText: {
    fontSize: 14,
    fontWeight: 600,
    minWidth: 0,
    mr: 1,
    overflowWrap: 'anywhere',
    textAlign: 'center',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
